<template>
  <div class="table-box setTable">
    <div class="tableBox">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" ref="table">
          <template slot-scope="{ row }" slot="id">
              <div class="key-name">{{row.templateName}}</div>
              <div class="key-id">模板ID：{{row.templateId}}</div>
            </template>
            <template slot-scope="{ row }" slot="type">
              <span v-if="row.templateType==0">平台</span>
              <span v-if="row.templateType==1">机构</span>
              <span v-if="row.templateType==2">团队</span>
              <span v-if="row.templateType==3">基准</span>
            </template>
            <template slot-scope="{ row }" slot="team">
              <span class="table-num" @click="openTemplateUserDetail(row)">{{row.applyNum}}</span>
            </template>
          <template slot-scope="{ row }" slot="productName">
            <div class="text-left">
              {{ row.productName }}
              <span class="tag gray" v-if="row.publishStatus == 1">已下架</span>
              <span class="tag gray" v-if="row.salesStatus == 1">停售</span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="fee">
            <div :class="{ 'red-text': row.isTemplate == 0 }" style="margin-right: 0">
              <template v-if="row.min != row.max">
                <span>{{ row.min }}%</span>-<span>{{ row.max }}%</span>
              </template>
              <span v-else>{{ row.min }}%</span>
            </div>
            <div class="huo" v-if="row.activityInfoVO && row.templateType == 3"><i>活</i>最高达{{ row.activityInfoVO.commission }}%</div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="seeRate(row)">查看费率</span>
            <!-- <span class="table-btn red" @click="delProduct(row)">删除</span> -->
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center;" />
      </div>
      <!-- 模板使用详情 -->
    <templateUserDetail ref="templateUserDetail" :workName="'workName'" @success="searchAjax"></templateUserDetail>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import templateUserDetail from "@/components/commons/feeTemplate/templateUserDetail";
export default {
  mixins: [common],
  components: { templateUserDetail },
  data(){
    return{
      tableLoading: false, //表格loading
      columns: [],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 5, //页容量
      pageNum: 1, //当前页
    }
  },
  methods:{
    // 打开模板使用者弹窗
    openTemplateUserDetail(item) {
      let params = {}
      params.id = item.templateId
      params.name = item.templateName
      params.type = item.templateType
      params.orgId = item.id
      this.$refs.templateUserDetail.open(params);
    },
    // 查看费率
    seeRate(row) {
      this.openPageTabTags('/productResource/fee/templateRateDetail', {
        productName: row.productName,
        templateName: row.templateName,
        templateId: row.templateId,
        companyName: row.companyName,
        productCode: row.productCode,
        nodeType: '2',
        orgId: this.userInfo.organId
      });
    },
    // 删除模板的单个产品
    delProduct(data) {
      if (!this.$units.pointAction('commission_20_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('确定删除产品？').then(() => {
        this.delAjax(data);
      });
    },
    // 删除产品请求
    delAjax(data) {
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      this.$http({
        url: '/buz/templateProduct/delTemplateProduct',
        type: 'post',
        data: {
          isAll: false,
          templateId: data.templateId,
          nodeType: '2',
          productCodes: [data.productCode],
        }
      })
        .then(res => {
          this.$notice.success('删除模板产品成功');
          this.searchAjax();
        })
        .finally(e => {
          this.tableLoading = false;
        });
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      this.tableLoading = true;
      this.$http({
        url: '/buz/workBenches/noComTemProduct',
        type: 'post',
        data: {
          nodeType:'2',
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
  },
  mounted(){
    let columns = [
      {
        title: "模板名称/ID",
        slot: "id",
        align: "left",
        width:220,
      },
      {
        title: "模板类型",
        slot: "type",
        align: "center",
        width:100
      },
      {
        title: "使用机构/团队",
        slot: "team",
        align: "center",
        width:130
      },
      {
        title: '产品名称',
        slot: 'productName',
        align: 'center',
        minWidth: 140
      },
      {
        title: '产品编码',
        key: 'productCode',
        align: 'center',
        minWidth: 140
      },
      {
        title: '保险公司',
        key: 'companyName',
        align: 'center',
        minWidth: 100
      }
    ];
    if (this.$units.showSupplier() && this.$units.pointAction('workbench_1')) {
      columns.push({
          title: '供应商',
          key: 'supplierName',
          align: 'center',
          minWidth: 140
        });
    }
    columns = columns.concat([
      {
        title: '服务费率',
        slot: 'fee',
        align: 'center',
        minWidth: 140
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        fixed:'right',
        width: 150
      }
    ]);
    this.columns = columns;
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.setTable{
  padding-bottom: 10px;
}
.table-num {
      color: #236dff;
      text-decoration: underline;
      cursor: pointer;
  }
  .tag {
    display: inline-block;
    line-height: 20px;
    height: 20px;
    border-radius: 4px;
    padding: 0 7px;
    margin-right: 10px;
    &.gray {
      background: #CED1D5;
      border: 1px solid #CED1D5;
      color: #515C6F;
    }
    &.red {
      background: #FFD8C7;
      border: 1px solid #FFD8C7;
      color: #FF7134;
    }
  }
</style>